import React, { useEffect } from 'react';
import { CheckCircle2, X, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const SuccessModal = ({ isOpen, onClose, applicantEmail }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="success-modal-overlay" onClick={onClose}>
      <div className="success-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="success-modal-close" onClick={onClose}>
          <X size={24} />
        </button>
        
        <div className="success-modal-body">
          {/* Animated Success Icon */}
          <div className="success-icon-wrapper">
            <CheckCircle2 className="success-icon" size={80} />
            <div className="success-sparkles">
              <Sparkles className="sparkle sparkle-1" size={24} />
              <Sparkles className="sparkle sparkle-2" size={20} />
              <Sparkles className="sparkle sparkle-3" size={28} />
            </div>
          </div>

          {/* Success Message */}
          <h2 className="success-title">Application Submitted!</h2>
          <p className="success-message">
            Thank you for your interest in becoming a Kitco News contributor. We're excited to review your application!
          </p>

          {/* Details Box */}
          <div className="success-details">
            <div className="success-detail-item">
              <span className="success-detail-label">Confirmation sent to:</span>
              <span className="success-detail-value">{applicantEmail}</span>
            </div>
            <div className="success-detail-item">
              <span className="success-detail-label">Review timeframe:</span>
              <span className="success-detail-value">5-7 business days</span>
            </div>
            <div className="success-detail-item">
              <span className="success-detail-label">Next steps:</span>
              <span className="success-detail-value">Our editorial team will contact you via email</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="success-actions">
            <Button onClick={onClose} className="success-button-primary">
              Perfect, Got It!
            </Button>
            <a 
              href="https://www.kitco.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="success-button-secondary"
            >
              Explore Kitco.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
